import React from 'react';
import { Mesocycle } from '../types';

interface MesocycleListProps {
  mesocycles: Mesocycle[];
  onSelectMesocycle: (mesocycle: Mesocycle) => void;
}

export const MesocycleList: React.FC<MesocycleListProps> = ({ mesocycles, onSelectMesocycle }) => {
  const getCurrentWeek = (mesocycle: Mesocycle): number => {
    const start = new Date(mesocycle.startDate);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const weeksLength = mesocycle.weeks?.length || 0;
    return Math.min(Math.ceil(diffDays / 7), weeksLength);
  };

  if (mesocycles.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 mb-4">No active mesocycles</p>
        <p className="text-sm text-gray-400">Create your first mesocycle to get started</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {mesocycles.map(mesocycle => {
        const currentWeek = getCurrentWeek(mesocycle);
        const totalWeeks = mesocycle.weeks?.length || 0;
        const progress = totalWeeks > 0 ? (currentWeek / totalWeeks) * 100 : 0;

        return (
          <div
            key={mesocycle.id}
            onClick={() => onSelectMesocycle(mesocycle)}
            className="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-shadow"
          >
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-lg font-semibold text-gray-900">{mesocycle.name}</h3>
              <span className="text-sm text-gray-500">
                Week {currentWeek} of {totalWeeks}
              </span>
            </div>

            <div className="mb-4">
              <div className="flex justify-between text-sm text-gray-600 mb-1">
                <span>Progress</span>
                <span>{Math.round(progress)}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>

            <div className="flex justify-between text-sm">
              <span className="text-gray-500">
                Started: {new Date(mesocycle.startDate).toLocaleDateString()}
              </span>
              <span className="text-gray-500">
                Ends: {new Date(mesocycle.endDate).toLocaleDateString()}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};